import { render, staticRenderFns } from "./FileTagPopUp.vue?vue&type=template&id=4099dd56"
import script from "./FileTagPopUp.vue?vue&type=script&lang=js"
export * from "./FileTagPopUp.vue?vue&type=script&lang=js"
import style0 from "./FileTagPopUp.vue?vue&type=style&index=0&id=4099dd56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports